import {Button, Grid, Icon, Typography} from "@mui/material";
import React from "react";
import {useLanguage} from "../../LanguageContext";
import {useIntl} from "react-intl";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const AltynGroup = () => {

    const {locale, changeLocale} = useLanguage();

    // console.log(locale)

    const intl = useIntl();


    const theme = useTheme()
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const isMd = useMediaQuery(theme.breakpoints.up('md'));

    let variant = 'h3'

    let secondVariant = 'subtitle2'

    if (isXs) {
        variant = 'h3';
        secondVariant = 'subtitle2'
    } else if (isMd) {
        variant = 'h2';
        secondVariant = 'subtitle1'
    }


    return  <Grid dir={locale === 'fa' ? 'rtl' : 'ltr'}>
        <Grid bgcolor={'rgba(255, 251, 242, 1)'} px={{xs: '18px', xxs: '27px', md: '75px', lg: '103px'}}
              pt={{xs: '145px', md: '176px'}} position="relative" zIndex={2} >

            <Grid border={'2px solid rgba(255, 191, 63, 1)'} borderRadius={'20px'} bgcolor={'white'}
                  px={{xs: '12px', xxs: '16px', md: '64px'}} pt={{xs: '24px', md: '32px'}}
                  pb={{xs: '36px', md: '64px'}} mb={{xs: '24px', md: '64px'}}>
                <Typography pb={'16px'} variant={variant} fontWeight={900} color={theme.palette.secondary.one}>
                    معرفی آلتن هولدینگ
                </Typography>

                <Grid display={"flex"}
                      justifyContent={"center"}
                      gap={2}
                      p={{md: '10px'}}>


                    <img src={"/assets/Images/company/group/ceo.png"} width={"300px"}/>
                    <img src={"/assets/Images/company/group/logo.png"}/>

                </Grid>

                <Typography textAlign={'justify'} variant={secondVariant} fontWeight={500}
                            color={theme.palette.secondary.one}>

                    <Typography pb={'16px'} variant={variant} fontWeight={600} color={theme.palette.secondary.one}>
                        چشم انداز
                    </Typography>


                    <p>
                        مجموعه شرکتهای التن هولدینگ، عضو مجامع بین المللی و بزرگترین مجموعه شرکتهای با مدیریت واحد در حوزه CIS از کشورهای آسیانه میانه، ایران، افغانستان و پاکستان است که با مدیریت کارآمد شرکتهای زیر مجموعه مستقر در کشورهای این حوزه در عرصه های مرتبط با لجستیک، اعم از فوروداردری و حمل و نقل ریلی، جاده ای و دریایی فعالیت نموده و عمده زنجیره تامین خود را از طریق چرخه همکاری شرکتهای زیرمجموعه برآروده می نماید و تمامی فعالیتهای اصلی مجموعه را، بر اساس بکارگیری
                        فناوری های پیشرفته در عرصه نرم افزاری و سخت افزاری و هوش مصنوعی مدیریت می نماید.
                    </p>

                    <br />
                    <Typography pb={'16px'} variant={variant} fontWeight={600} color={theme.palette.secondary.one}>
                        اهداف
                    </Typography>
                    <ul>
                        <li>جانمایی شرکت های زیرمجموعه به عنوان ارکان موثر در اکوسیستم لجستیک و حمل و نقل منطقه</li>
                        <li>طراحی و راه اندازی سامانه یکپارچه آلتن لینک و مدیریت بیش از 50 درصد از حاملین کالا )اعم
                            از واگنهای ریلی، حمل و نقل کانتینری ریلی، جاده ای و دریایی) در منطقه از طریق این سامانه </li>
                        <li>توسعه شرکتهای زیرمجموعه در حوزه های مختلف حمل و نقل جاده ای، حمل و نقل ریلی، حمل و
                            نقل دریایی
                        </li>
                        <li>توسعه شرکتهای زیرمجموعه پشتیبان در زنجیره تامین مانند شرکتهای تخصصی فناوری اطلاعات
                            و ارتباطات، صرافی بین المللی، گروه مشاورین لجستیک، آموزش و تربیت نیروی انسانی، تولید
                            تجهیزات تخصصی لجستیک مورد نیاز در منطقه</li>
                        <li>کاهش ریسک پذیری زیرمجموعه از طریق همکاری، تعامل و تهاتر داخلی در شرکتهای
                            زیرمجموعه آلتن لجستیک </li>
                        <li>افزایس سود دهی شرکتهای زیر مجموعه از طریق کاهش هزینه های تمام شده، تهاتر بین المللی و
                            افزایش بهره وری </li>
                        <li>ارتقای شایستگی های نیروی انسانی و تبدیل آلتن هولدینگ به مجموعه ای یادگیرنده و سازمانی
                            دانشی </li>
                        <li>توسعه تحقیق و توسعه و تعریف پروژه های مستمر در توسعه مجموعه آلتن لجستیک و سرمایه
                            گذاری در عرصه های تخصصی و غیر تخصصی با هدف افزایش نقدینگی و کاهش ریسک </li>
                        <li>ورود در مجامعه بین المللی رسمی در حوزه لجستیک و اثرگذاری در تصمیم گیری های بین المللی
                            در این حوزه </li>
                        <li>رصد و ارزیابی مستمر اکوسیستم حمل و نقل منطقه و مناطق تاثیرگذار برای تدوین و بروز
                            رسانی استراتژی توسعه مجموعه </li>
                    </ul>



                    <br />
                    <Typography pb={'16px'} variant={variant} fontWeight={600} color={theme.palette.secondary.one}>
                        برنامه ها
                    </Typography>
                    <ul>
                        <li>راه اندازی شرکت آلتن افغان در کشور افغانستان با اهداف: 1) سودآوری از طریق فورواردری
                            حمل و نقل در ایستگاههای آقینه و ترغندی 2) پیشنهاد پروژه همکاری در توسعه فعالیتهای مبادله  واگنی با راه آهن ترکمنستان به نمایندگی از راه آهن افغانستان با تجهیز و راه اندازی و توسعه
                            ایستگاه 3) ترغیب صاحبان واگن های آسیانه میانه به سیر برگشت از طریق مرز اینچه برون و افزایش دبی ورودی واگنهای شرکتهای آلتن ریل و آلتن میراث و اجاره واگنهای مازاد به شرکتهای مستقر در این ایستگاه 4) توسعه زنجیره تامین شرکتهای زیرمجموعه در حوزه تبادلات مالی غیر
                            رسمی</li>
                        <li> راه اندازی پروژه سرهنگ در منطقه خراسان رضوی، با اهداف: 1) سودآوری از طریق انجام
                            خدمات تخصصی بندر خشک 2) افزایش سبد دارایی های غیرمنقول شرکت از طریق ارزش
                            افزوده سرمایه گذاری 3) افزایش بهره وری در ارائه خدمات حمل و نقل بدلیل موقعیت استراتژیک پروژه و قابلیت ارائه خدمات در مرزهای افغانستان و ترکمنستان</li>
                        <li>راه اندازی آلتن لینک با هدف ایجاد سامانه یکپارچه مدیریت حمل و نقل ریلی در منطقه با امکانات
                            فوق العاده برای صاحبان واگنها و مشتریان واگن </li>
                        <li>
                            توسعه آلتن پورتال با راه اندازی سامانه های مدیریت حمل و نقل کانتینری بین المللی در مسیرهای
                            ریلی، جاده ای و دریایی
                        </li>
                        <li>راه اندازی شرکت صرافی بین المللی برای تکمیل زنجیره تامین و تارکنشهای مالی شرکتهای
                            زیرمجموعه برای: 1) احترام به قوانین سفافیت مالی در کشورهای آسیای میانه و 2) احترام به  حقوق مشتریان در پرداختها از روشهای مختلف در کشورهای ایران و افغانستان و روسیه و امثالهم</li>
                        <li>طراحی و راه اندازی سامانه جامع اتوماسیون داخلی شرکتهای زیرمجموعه با اهداف: 1) کاهش
                            زمان ورود اطلاعات در فرآیندها 2) افزایش دقت و حذف خطای انسانی در ورود اطلاعات 3)  کاهش وابستگی به نیروی انسانی و افزایش بهره وری 4) بازمهندسی فرآیندها و حذف فرآیندهای
                            زائد و حرکت به سمت دریافت گواهینامه های بین المللی مدیریت مانند ایزو</li>
                        <li> ثبت هولدینگ بین المللی آلتن لجستیک و ورود به مجامع بین المللی مرتبط از طریق عضویت و
                            انجام فعالیتهای تاثیرگذار در منطقه
                        </li>
                        <li>راه اندازی مرکز آموزشهای تخصصی لجستیک با اهداف: 1) استعدادیابی و تربیت نیروی انسانی
                            لازم برای شرکتهای زیرمجموعه، 2) درآمدزایی از طریق ارائه برنامه های آموزشی، 3) ارتقای
                            برندینگ، 4) توسعه R&D از طریق همکاری نخبگان لجستیک و فناوری 5) ایده یابی و تعریف پروژه های توسعه در مسیر بلوغ هولدینگ التن</li>
                        <li>تعریف مشاغل سازمانی در مجموعه شرکتهای التن لجستیک و تهیه مسیرهای ارتقای شغلی برای
                            هدف گذاری و افزایش انگیزه در پرسنل </li>
                        <li>راه اندازی آلتن شیپینگ در بندر امیرآباد برای توسعه حمل و نقل دریایی از طریق دریای
                            خزر و تکمیل زنجیره حمل و نقل بین المللی کانتینری در خط سیر دریایی </li>
                        <li>راه اندازی گروه مشاورین لجستیک با اهداف: 1) سودآوری از طریق مشاوره به تازه واردین
                            عرصه صادرات و واردات کالا 2) سودآوری از طریق مشاوره به صاحبان کانتینرهای حمل در  مقاصد انتهایی برای باردار شدن مجدد کانتینرها و برگشت سودآور به سمت مقاصد ثالث 3) تهیه محتواهای آموزشی تخصصی و فروش آنلاین 4) جمع آوری اطلاعات بروز از وضعیت لجستیک
                            منطقه از طریق گوش فرادهی به مخاطبین 5) افزایش ورودی مخاطبین آلتن لینک و آلتن پورتال از طریق هدایت غیرمستقیم</li>
                        <li>توسعه شرکت های زیرمجموعه در عرصه اکسپدیتوری در کشور قزاقستان و ترکمنستان
                            برای تامین نیازهای شرکتهای زیرمجموعه و سودآوری و نیز کاهش ریسک وابستگی به یک  شرکت خاص</li>
                        <li>توسعه فعالیتهای بازاریابی و مدیریت بازار از طریق تحلیل بازارهای هدف و ارتباط موثر با
                            مخاطبین </li>
                        <li>راه اندازی آلتن کارگو با هدف پاسخگویی به نیاز مشتریانی که استراتژی "درب تا درب" را
                            برگزیده اند و حاضرند با پرداخت تمامی هزینه های حمل و نقل و مسئولیت، انتقال کالای خود را  از درب انبار کارخانه به صورت یکجا به فوروادر واگذار نمایند. (مشتریان EXW)</li>
                  
                    </ul>

                </Typography>
            </Grid>
        </Grid>
    </Grid>
}

export default AltynGroup;